export const BULAN = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];
export const BULAN_OPTS = BULAN.map((b, i) => ({ value: String(i + 1), label: b }));
export const TAHUN = ["2026", "2027", "2028", "2029", "2030"];
export const TAHUN_OPTS = TAHUN.map((t) => ({ value: t, label: t }));
export const TAHUN_AJARAN = ["2026/2027", "2027/2028", "2028/2029", "2029/2030"];
export const SEMESTER_LAPORAN = ["Tengah Semester I", "Akhir Semester I", "Tengah Semester II", "Akhir Semester II"];
export const SEMESTER_BATAS = ["Semester I", "Semester II"];
export const HARI = ["Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"];
export const JENIS_IZIN = ["Terlambat", "Sakit", "Izin", "Pulang Cepat"];
export const KETUNAAN = ["A-Tuna Netra", "B-Tuna Rungu", "C-Tuna Grahita Ringan", "C1-Tuna Grahita Sedang", "D-Tuna Daksa Ringan", "D1-Tuna Daksa Sedang", "E-Tuna Laras", "F-Tuna Wicara", "H-Hiperaktif", "I-Cerdas Istimewa", "K-Kesulitan Belajar", "N-Narkoba", "P-Down Syndrome", "Q-Autis"];
export const MAPEL_AKADEMIK = ["Matematika", "Pendidikan Pancasila", "PAI", "Bahasa Inggris", "IPAS", "Bahasa Indonesia", "Calistung", "PJOK", "IPA", "IPS"];
export const MAPEL_NON = ["Seni Musik", "Seni Tari", "Seni Lukis", "Tata Boga", "TIK", "Desain Grafis", "Prakarya", "Pengembangan Diri", "OMSK", "Komunikasi", "Pramuka", "Athletik"];
export const SECTIONS = [
  ["sosialisasi", "KEMAMPUAN BERSOSIALISASI"],
  ["komunikasi", "KEMAMPUAN BERKOMUNIKASI"],
  ["perilaku", "KEMAMPUAN BERPERILAKU"],
  ["bina_diri", "KEMAMPUAN BINA DIRI DAN KEMANDIRIAN"],
  ["akademik", "KEMAMPUAN AKADEMIK"],
];
export const SUBS = [["kondisi", "Kondisi Siswa Pendampingan"], ["target", "Target Pendampingan"], ["pencapaian", "Pencapaian Siswa Pendampingan"]];
export const ROLE_LABEL = { admin: "Admin", koordinator: "Koordinator", guru: "Guru", ortu: "Orang Tua" };
export const YAYASAN = "Yayasan Bintang Pelita Nusa";

export const rupiah = (n) => (n || n === 0 ? "Rp " + Number(n).toLocaleString("id-ID") : "–");
export const rp = (n) => (n ? "Rp " + Number(n).toLocaleString("id-ID") : "–");
export const tgl = (s) => {
  if (!s) return "-";
  const d = new Date(s.length <= 10 ? s + "T00:00:00" : s);
  if (isNaN(d)) return s;
  return `${String(d.getDate()).padStart(2, "0")}-${String(d.getMonth() + 1).padStart(2, "0")}-${d.getFullYear()}`;
};
export const tglPanjang = (s) => {
  if (!s) return "-";
  const d = new Date(s.length <= 10 ? s + "T00:00:00" : s);
  return `${d.getDate()} ${BULAN[d.getMonth()]} ${d.getFullYear()}`;
};
export const waktu = (s) => (s ? new Date(s).toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "short" }) : "-");
export const todayISO = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};
export const namaBulan = (m) => BULAN[Number(m) - 1] || "-";
